<template>
    <div class="rule">
        <el-dropdown @command="addCvrRule">
            <el-button type="success">
                Add Condition<i class="el-icon-arrow-down el-icon--right"></i>
            </el-button>
            <el-dropdown-menu slot="dropdown">
                <el-dropdown-item command="1">Daily Min. CVR</el-dropdown-item>
                <el-dropdown-item command="2">Daily Max. CVR</el-dropdown-item>
            </el-dropdown-menu>
        </el-dropdown>
        <el-button type="danger" @click="delAll" class="del-all">Delete All</el-button>
        <div v-for="(data,key) in offer_cvr_rule" :key="key" :title="title">
            <div :class="data.cvr_condition">{{title[key]}}</div>
                <el-input v-model="data.min_click" placeholder="Click" class="rule-input" @blur="setCvrRule" type='number'/>
                <el-input v-model="data.cvr" placeholder="CVR" class="rule-input" @blur="setCvrRule" type='number'/>
                <el-checkbox v-model="data.block_click" class="rule-input" @change="setCvrRule">Block Click</el-checkbox>
                <el-checkbox v-model="data.block_conv" class="block-conv" @change="setCvrRule">Block Conv.</el-checkbox>
                <el-button type="danger" @click="delOne(key)" class="rule-input">DEL</el-button>
        </div>
    </div>
</template>

<script>
export default {
	data() {
		return{
            offer_cvr_rule:[],
            is_first:true,
            title:[],
		}
	},
    props:['value'],
    watch: {
        value:function(cvr_rule_json) {
            if(this.is_first) {
                // console.log(urls);
                this.is_first = false;
                let cvr_rule_obj = JSON.parse(cvr_rule_json);
                if(cvr_rule_obj != null) {
                    for(const k in cvr_rule_obj['daily_cvr']) {
                        cvr_rule_obj['daily_cvr'][k]['block_click'] = cvr_rule_obj['daily_cvr'][k]['block_click'] == 1 ? true:false;
                        cvr_rule_obj['daily_cvr'][k]['block_conv'] = cvr_rule_obj['daily_cvr'][k]['block_conv'] == 1 ? true:false;
                        this.offer_cvr_rule.push(cvr_rule_obj['daily_cvr'][k]);
                        if(cvr_rule_obj['daily_cvr'][k]['cvr_condition'] == 'min_cvr'){
                            this.title.push('Daily Min. CVR(%)');
                        }
                        else{
                            this.title.push('Daily Max. CVR(%)');
                        }
                    }
                }
            }
        }
    },
    methods: {
        addCvrRule: function(type) {
            let new_rule = new Object;
            new_rule.block_click = false;
            new_rule.block_conv = false;
            new_rule.condition = "excluded";
            new_rule.cvr = "";
            new_rule.cvr_condition = "";
            new_rule.min_click = "";
            if(type == '1'){
                new_rule.cvr_condition = "min_cvr";
                this.title.push('Daily Min. CVR(%)');
            }
            else{
                new_rule.cvr_condition = "max_cvr";
                this.title.push('Daily Max. CVR(%)');
            }
            this.offer_cvr_rule.push(new_rule);
        },
        delAll: function() {
            this.offer_cvr_rule = [];
            this.title = [];
            this.setCvrRule();
        },
        delOne: function(key) {
            this.offer_cvr_rule.splice(key,1);
            this.title.splice(key,1);
            this.setCvrRule();
        },
        setCvrRule: function() {
            const result = new Object;
            let rule = new Object;
            result.daily_cvr = [];
            for(const k in this.offer_cvr_rule){
                rule[k] = {};
                if(this.offer_cvr_rule[k]['cvr'] == '' || this.offer_cvr_rule[k]['cvr_condition'] == '') continue;
                rule[k].block_click = this.offer_cvr_rule[k]['block_click'] == true ? 1:0;
                rule[k].block_conv = this.offer_cvr_rule[k]['block_conv'] == true ? 1:0;
                rule[k].condition = "excluded";
                rule[k].cvr = this.offer_cvr_rule[k]['cvr'];
                rule[k].cvr_condition = this.offer_cvr_rule[k]['cvr_condition'];
                rule[k].min_click = this.offer_cvr_rule[k]['min_click'];
                result.daily_cvr.push(rule[k]);
            }
            this.$emit('input',JSON.stringify(result));
        }
    }
}
</script>

<style scoped >
.rule {
    display: flex;
    flex-wrap: wrap;
}
.del-all {
    margin-left: 30px;
}
.min_cvr {
    color: red;
    font-weight: bolder;
}
.max_cvr {
    color: blue;
    font-weight: bolder;
}
.rule-input {
    width:16%;
    margin-right:10px;
}
.block-conv {
    width:20%;
    margin-right:10px;
}
</style>

